var render = function render(){var _vm=this,_c=_vm._self._c;return _c('IconBtn',{attrs:{"icon":"mdi-sync","title":"Push Menu","loading":_vm.loading,"x-small":_vm.xSmall,"small":_vm.small},on:{"click":function($event){$event.stopPropagation();return _vm.submit.apply(null, arguments)}}})
}
var staticRenderFns = []

export { render, staticRenderFns }